module.exports = __webpack_public_path__ + "static/media/review-1.e10bd612.png";